import firebase from 'firebase/compat/app';
import 'firebase/compat/database'
import 'firebase/compat/analytics'
import 'firebase/compat/auth'

export const firebaseConfig = {
  apiKey: "AIzaSyAu55s9U3N9j1MPM_Fa50_Ba9VNtTG-C3Q",
  authDomain: "brocashamburgueria.firebaseapp.com",
  databaseURL: "https://brocashamburgueria-default-rtdb.firebaseio.com",
  projectId: "brocashamburgueria",
  storageBucket: "brocashamburgueria.appspot.com",
  messagingSenderId: "887761303092",
  appId: "1:887761303092:web:fbb8ed118f7c9607c1bc61",
  measurementId: "G-G9N4FFXT03"
};


export const firebaseImpl = firebase.initializeApp(firebaseConfig);
export const firebaseAuth = firebase.auth();
export const firebaseAnalytics = firebase.analytics(firebaseImpl);
export const firebaseDatabase = firebase.database();
export default firebase;